import React from 'react'
import { useInView } from 'react-intersection-observer'

const Flipbook = ({data}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  return (
    <div className={`flipbook ${inView ? 'has-anim' : ''}`} ref={ref}>
      <div className="scroll-anim-el" dangerouslySetInnerHTML={{__html: data.iframe}}></div>
    </div>
  )
}


export default Flipbook
